<template>
	<div class="key-cutting-machine-list">
		<div class="key-cutting-machine-con">
			<div class="title">
				<i class="x-icon-keys"></i><span class="x-tit-con">Key Cutting Machine Solutions</span>
			</div>

			<div class="list">
				<p>
					To better meet the demands of the automotive industry, we successfully developed the Xhorse's first CNC key processing machine that represented a milestone, turned into the first one in China. Regardless of the mechanical mechanism and software, All the machines we developed take their place in the front ranks of the automotive security solutions worldwide. We have successively invested and developed the smallest CNC key processing machine in the world over the past several years.</p>
				<ul>
					<li><img :src="solution_image_01" alt="Xhorse"/>
						<div class="prod-name">CONDOR</div>
					</li>
					<li><img :src="solution_image_02" alt="Xhorse"/>
						<div class="prod-name">DOLPHIN</div>
					</li>
					<li><img :src="solution_image_03" alt="Xhorse"/>
						<div class="prod-name">PANDA</div>
					</li>
				</ul>
				<div class="instruction">
					<p>
						The functional, stable, and precise automatic key cutting machines that allow you to duplicate various keys. The powerful built-in key database and Intelligent software-guided cutting procedures support all key lost, cut by bitting, find bitting, etc. Xhorse automatic key cutting machines are easy to use and guide you through the key duplicating process step by step. </p>

					<p>Besides, we also provide you the mechanical key cutting solutions to duplicate keys with high
						precision and durability; with the ergonomics designed body structure, equipped with multiple specialized clamps the mechanical key cutting machines enable you flexibly cut vehicle, household, and other security keys.</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
    import solution_image_01 from '@/assets/resource/images/solution/image_solutions_key_condor.png'
    import solution_image_02 from '@/assets/resource/images/solution/image_solutions_key_dolphin.png'
    import solution_image_03 from '@/assets/resource/images/solution/image_solutions_key_panda.png'
    export default {
        data(){
            return {
                solution_image_01: solution_image_01,
                solution_image_02: solution_image_02,
                solution_image_03: solution_image_03,
            };
        }
    }

</script>

<style scoped>


	.list > p {
		width: 100%;
		font-size: 1rem;
		color: #515555;
		letter-spacing: 0;
		text-align: justify;
		line-height: 1.5rem;
		margin-left: 0;
	}

	.instruction > p {
		width: 100%;
		font-size: 1rem;
		color: #515555;
		letter-spacing: 0;
		text-align: justify;
		line-height: 1.5rem;
	}

	.instruction > p:nth-child(2) {
		margin-top: 1.375rem;
	}

	.prod-name {
		font-size: 1.25rem;
		color: #515555;
		letter-spacing: 0;
		text-align: justify;
		margin-top: 1.5rem;
	}

	.list > ul > li > img, .list > ul > li > .prod-name {
		width: 100%;
	}

	.list > ul > li {
		width: calc((100% - 3rem) / 3);
		border: none;
		float: left;
	}

	.list > ul > li:nth-child(2) {
		margin-left: 1.5rem;
		margin-right: 1.5rem;
	}

	.list > .instruction {
		margin-top: 4.0625rem;
		height: 12rem;
		margin-bottom: 6.125rem;
	}

	.list > ul, .list > .instruction {
		width: 100%;
		margin-left: 0px;
	}

	.list > ul {
		margin-top: 2.75rem;
		height: 16.1875rem;
		position: relative;
	}

	.list > ul > li:last-child {
		position: absolute;
		right: 0;
	}

	.key-cutting-machine-list {
		min-width: 61.5rem;
		min-height: 62.125rem;
		overflow: hidden;
	}

	.key-cutting-machine-con {
		width: 61.5rem;
		margin-left: 0;
		height: 53.25rem;
	}

	.list {
		margin-left: 7rem;
	}

	.title {
		width: calc(100% - 3.25rem);
		text-align: left;
		margin-left: 3.25rem;
		margin-top: 2.75rem;
		margin-bottom: 2.75rem;

	}

	.x-tit-con {
		font-size: 1.5rem;
		color: #3B3A38;
		line-height: 3.25rem;
	}

	.warnning {

		width: 100%;
		height: 100px;
		margin: 0 auto;
		text-align: center;
		font-style: oblique;
		font-size: 4rem;
		font-family: "Open Sans";
		margin-top: 2.75rem;
		margin-bottom: 2.75rem;

	}

	.x-icon-keys {
		display: inline-block;
		content: url("../../../assets/resource/icons/ico_solutions.png");
		width: 2.75rem;
		height: 2.75rem;
		position: relative;
		top: .625rem;
		margin-right: 1rem;
	}

</style>


// WEBPACK FOOTER //
// src/components/zh-cn/solution/solution-key-cutting-machine.vue